import {useState} from "react";
import axios, {AxiosRequestConfig} from "axios";
import {getProviderServer} from "./HostUtils";
import {useKensuAuth} from "./authwrapper/AuthWrapper";

export const useImageUploader = () => {

  const {getIdTokenClaims} = useKensuAuth()
  const [uploadProgress, setUploadProgress] = useState(0);
  
  /**
   * Selecting a file automatically uploads it to cloud storage and then renders the
   * image from that hosting URL.
   */
  const upload = (file: File | null | undefined): Promise<string> => {

    return new Promise<string>((resolve, reject) => {

      if (!file) {
        reject('no file selected');
        return;
      }

      if (file.size > (5 * 1024 * 1024)) {
        reject('Image exceeds max size of 5 MB')
        return;
      }

      getIdTokenClaims()
          .then(token => {

            const url = `${getProviderServer()}/upload`;
            const formData = new FormData();
            formData.append('file', file);
            const config: AxiosRequestConfig = {
              headers: {
                'Authentication': token?.__raw ?? '',
                'Content-Type': 'multipart/form-data',
              },
              onUploadProgress: (progressEvent) => {
                setUploadProgress(Math.round((progressEvent.loaded * 100) / (progressEvent.total ?? file.size)));
              },
            };
            axios.post(url, formData, config)
                .then((response) => {
                  resolve(response.data);
                })
                .catch((error) => {
                  reject(error.toString());
                })
                .finally(() => {
                  setUploadProgress(0);
                });
          })
          .catch(e => {
            reject("Auth error. " + e.toString());
          });
    });
  }
  
  return {
    upload: upload,
    uploadProgress: uploadProgress,
  }
};